import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Select from "react-select";
import "../../styles/AddUserDetails.scss";
import Multiselect from "multiselect-react-dropdown";
import profileimg from "../../images/profile-1.png";
import { SBSaveUpdateBtn } from "../SbButtons/SbAddBtn";
import SbCancelBtn from "../SbButtons/SbCancelBtn";
import { baseURL } from "../BaseUrl";
import {
  loadDesignationDrop,
  loadShiftDropdown,
  loadStateList,
  loadUserRegion,
} from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import * as swal from "../Consturl/SwalAlert";
import "react-toastify/dist/ReactToastify.css";
import { FloatingLabel, OverlayTrigger, Tooltip } from "react-bootstrap";
import { salesbeeImgAuth, travelizeAuth } from "../HeaderAuthentication";
import { textNameValidation } from "../FormattedAmount";
import { toast } from "react-toastify";
import Geocode from "react-geocode";
import { React_Google_API_Key } from "../../GoogleApiKey";
import { optionsMapByListModel } from "../DropdownsData";
import GoogleMapAddressModel from "../GoogleMapAddressModel";
import AddEditFormComponent from "../ReUseComponents/AddEditFormComponent";
Geocode.setApiKey(React_Google_API_Key);

const UpdateUserData = (props) => {
  let dispatch = useDispatch();

  const { userRegionResult } = useSelector((state) => state.data);
  const { stateList } = useSelector((state) => state.data);
  const { shiftDropdownData } = useSelector((state) => state.data);
  const { desigationdrop } = useSelector((state) => state.data);

  const [fullname, setFullname] = useState("");
  const [usercode, setUserCode] = useState("");
  const [emailaddress, setEmailAddress] = useState("");
  const [mobilenum, setMobileNum] = useState(0);
  const [stateForHoliday, setStateForHoliday] = useState("");
  const [location, setLocation] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [manager, setManager] = useState("");
  const [enableStatus, setEnableStatus] = useState();
  const [country, setCountry] = useState("");
  const [shift, setShift] = useState(0);
  const [oldShift, setOldShift] = useState("");
  const [googleMapsModel, setGoogleMapsModel] = useState(false);
  const [imgFile, setImgFile] = useState("");
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [localImage, setLocalImage] = useState(null);
  const [zone, setZone] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [zoneList, setZoneList] = useState([]);
  const [stateListDropdown, setStateListDropdown] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [countryCodeList, setCountryCodeList] = useState([]);

  const [managerList, setManagerList] = useState([]);
  const [selectedOldCities, setSelectedOldCities] = useState([]);
  const [imgFileName, setImgFileName] = useState("");
  const [zoneIds, setZoneIds] = useState([]);
  const [stateIds, setStateIds] = useState([]);
  const [cityIds, setCityIds] = useState([]);
  const [countryId, setCountryId] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [address, setAddress] = useState("");
  const [mapById, setMapById] = useState("");
  // const [userRegionResult, setUserRegionResult] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState({
    alertType: "",
    message: "",
  });
  const [fieldReq, setFieldReq] = useState(false);
  const [latLan, setLatLan] = useState({
    lat: null,
    lng: null,
  });
  const [reportDesignation, setReportDesignation] = useState(0);

  const [countryVal, setCountryVal] = useState("");
  const [designationVal, setDesignationVal] = useState("");
  const [managerVal, setManagerVal] = useState("");
  const [countryName, setCountryName] = useState("");
  const [shiftVal, setShiftVal] = useState("");
  const [mapByVal, setMapByVal] = useState({
    value: 0,
    label: "",
  });
  const [minMeetingRange, setMinMeetingRange] = useState("");
  const [stateSpecificHolidayVal, setStateSpecificHolidayVal] = useState("");

  const hiddenFileInput = useRef("");

  const handleChange = (event) => {
    setProfileImageUrl(true);
    const fileUploaded = event.target.files[0];
    setImgFile(fileUploaded);
    setImgFileName(event.target.files[0].name);
    const reader = new FileReader();
    reader.readAsDataURL(fileUploaded);
    reader.onloadend = () => {
      setLocalImage(reader.result);
    };
  };

  const uploadClick = () => {
    hiddenFileInput.current.click();
  };

  // ADDRESS FROM GOOGLE MAPS START

  const openGoogleMaps = () => {
    setGoogleMapsModel(!googleMapsModel);
  };

  // ADDRESS FROM GOOGLE MAPS END

  //* FETCH DROPDOWN DATA START *//
  useLayoutEffect(() => {
    dispatch(loadStateList(0));
    dispatch(loadShiftDropdown());
    dispatch(loadDesignationDrop(1));
  }, []);

  useEffect(() => {
    dispatch(loadUserRegion(props.userID));
  }, [props.userID]);

  useEffect(() => {
    fetchDropdownData();
  }, [zoneIds, stateIds]);

  const fetchDropdownData = () => {
    let stateResponse = userRegionResult?.allStates;
    setStateListDropdown(
      stateResponse
        ?.filter((z) => zoneIds.includes(z.zoneId))
        ?.map((item) => item) ?? []
    );
    let cityResponse = userRegionResult?.allCities;
    setCityList(
      cityResponse
        ?.filter((s) => stateIds.includes(s.stateId))
        ?.map((item) => item) ?? []
    );
  };

  // FETCH USERDETAILS FOR EDIT START
  useLayoutEffect(() => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/User/UserDetails/${props.userID}`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        setFullname(res.result?.fullName);
        setMinMeetingRange(res.result?.allowMeetings);
        setUserCode(res.result?.code);
        setEmailAddress(res.result?.email);
        setMobileNum(res.result?.contact);
        setLocation(res.result?.baseLoc?.location);
        setAddress(res.result?.baseLoc?.location);
        setLatLan({
          lat: JSON.parse(res.result?.baseLoc?.latitude),
          lng: JSON.parse(res.result?.baseLoc?.longitude),
        });
        setCountryCode(res.result?.countryCode);
        setManager(res.result?.managerId);
        setEnableStatus(res.result?.enableStatus);
        setProfileImageUrl(res.result?.profilePic);
        setShift(+res.result?.shiftID);
        setOldShift(res.result?.shiftID);
        setMapById(res.result?.mapType);
        setReportDesignation(res.result?.desingation?.designationID);
        setStateForHoliday(res.result?.stateSpecificHoliday);
      })
      .catch((error) => {
        console.error("ERROR:---", error);
        setErrorMessage(error.message);
      });
  }, [props.userID]);
  // FETCH USERDETAILS FOR EDIT END

  useEffect(() => {
    {
      Object.keys(userRegionResult).length > 0 && setSelectedRegions();
    }
  }, [props.userID, userRegionResult]);

  const setSelectedRegions = () => {
    setCountryList(
      userRegionResult?.allCountry?.map((data) => {
        return { value: data.countryID, label: data.countryName };
      })
    );
    setCountryCodeList(
      userRegionResult?.allCountryCode?.map((data) => {
        return { value: data.code, label: data.code };
      })
    );
    setZoneList(userRegionResult?.allZones);
    setCountryId(userRegionResult?.selectedCountryID[0]);
    setCountry(userRegionResult?.selectedCountry?.countryName);
    let zones = [
      ...new Set(userRegionResult?.userRegions?.map((z) => z.zoneName)),
    ];
    let states = [
      ...new Set(userRegionResult?.userRegions?.map((s) => s.stateName)),
    ];
    let cities = [
      ...new Set(userRegionResult?.userRegions?.map((c) => c.cityName)),
    ];
    setSelectedOldCities(cities);
    setZone(
      userRegionResult.allZones.filter((z) => zones.includes(z.zoneName))
    );
    setState(
      userRegionResult.allStates.filter((s) => states.includes(s.stateName))
    );
    setCity(
      userRegionResult.allCities.filter((c) => cities.includes(c.cityName))
    );
    let zonesId = [
      ...new Set(userRegionResult.userRegions.map((z) => z.zoneId)),
    ];

    let statesId = [
      ...new Set(userRegionResult?.userRegions?.map((s) => s.stateId)),
    ];
    let citiesId = [
      ...new Set(userRegionResult?.userRegions?.map((c) => c.cityId)),
    ];
    setZoneIds(zonesId);
    setStateIds(statesId);
    setCityIds(citiesId);
  };

  useEffect(() => {
    fetchZoneStateCityselectedList();
  }, [reportDesignation]);

  const fetchZoneStateCityselectedList = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/User/BindTopManagerDropDown/${reportDesignation}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setManagerList(
            res.result.map((data) => {
              return { value: data.userId, label: data.userFullName };
            })
          );
        } else {
          setManagerList([]);
        }
      })
      .catch((error) => {
        console.log("ERROR :", error);
        setErrorMessage(error.message);
      });
  };
  //* FETCH DROPDOWN DATA END *//

  // MULTI SELECT DROPDOWN FUNCTION START
  const handleSelectZone = (selectedList) => {
    setZone(selectedList);
    setZoneIds(selectedList.map((z) => z.zoneId));
  };
  const handleRemoveZone = (selectedList) => {
    setZone(selectedList);
    setZoneIds(selectedList.map((z) => z.zoneId));
  };
  const handleSelectState = (selectedList) => {
    setState(selectedList);
    setStateIds(selectedList.map((s) => s.stateId));
  };
  const handleRemoveState = (selectedList) => {
    setState(selectedList);
    setStateIds(selectedList.map((s) => s.stateId));
  };
  const handleSelectCity = (selectedList) => {
    setCity(selectedList);
    setCityIds(selectedList.map((s) => s.cityId));
  };
  const handleRemoveCity = (selectedList) => {
    setCity(selectedList);
    setCityIds(selectedList.map((s) => s.cityId));
  };
  // MULTI SELECT DROPDOWN FUNCTION END

  //  ADDING PROFILE IMAGE BY USER START
  const editProfileImg = (e) => {
    e.preventDefault();
    if (profileImageUrl == true && imgFile !== null && imgFile !== "") {
      const formData = new FormData();
      formData.append("image", imgFile);
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: salesbeeImgAuth,
        body: formData,
      };
      fetch(
        `${baseURL}/api/Upload/UploadProfile?directory=Profile`,
        requestOption
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            var imgUrl = res.result[0];
            editUser(imgUrl);
          } else {
            setProfileImageUrl(res.success);
            // setImgFileName(`${res.errorMessage}`);
            toast.error(res.errorMessage, { autoClose: 8000 });
          }
        });
    } else {
      editUser();
    }
  };
  //  ADDING PROFILE IMAGE BY USER END

  // VALIDATIONS START
  const checkValidation = (e) => {
    e.preventDefault();
    const re = /^[0-9\b]+$/;
    if (e.target.value === "" || re.test(e.target.value)) {
      setMobileNum(e.target.value);
    } else {
      setFieldReq(true);
      setAlertMessage({ alertType: "fails", message: "Accept only numbers" });
    }
  };
  // VALIDATIONS END

  // SET EXISTING VALUE TO DROPDOWN START
  useEffect(() => {
    if (countryCode !== null && countryCode !== "") {
      countryCodeList.map((contry) => {
        if (countryCode == contry.value) {
          setCountryVal(contry);
        }
      });
    }
    if (reportDesignation !== null && reportDesignation !== "") {
      desigationdrop.map((designation) => {
        if (reportDesignation == designation.value) {
          setDesignationVal(designation);
        }
      });
    }
    if (manager !== null && manager !== "") {
      managerList.map((mngrlist) => {
        if (manager == mngrlist.value) {
          setManagerVal(mngrlist);
        }
      });
    }
    if (countryId !== null && countryId !== "") {
      countryList.map((cntrList) => {
        if (countryId == cntrList.value) {
          setCountryName(cntrList);
        }
      });
    }
    if (shift !== null && shift !== "") {
      shiftDropdownData.map((shifts) => {
        if (shift == shifts.value) {
          setShiftVal(shifts);
        }
      });
    }

    if (mapById !== null && mapById !== "") {
      optionsMapByListModel.map((maplist) => {
        if (mapById == maplist.value) {
          setMapByVal(maplist);
        }
      });
    }
    if (stateForHoliday !== null && stateForHoliday !== "") {
      stateList.map((state) => {
        if (stateForHoliday == state.label) {
          setStateSpecificHolidayVal(state);
        }
      });
    }
  }, [
    manager,
    countryCode,
    reportDesignation,
    countryId,
    shift,
    shiftDropdownData,
    mapById,
    managerList,
    stateForHoliday,
  ]);
  // SET EXISTING VALUE TO DROPDOWN END

  // EDIT USER START
  const editUser = (imgUrl) => {
    if (
      countryCode !== "" &&
      (countryCode === "+91"
        ? mobilenum.toString().length == 10
        : mobilenum.toString().length >= 6) &&
      location !== "" &&
      country !== "" &&
      zoneIds !== "" &&
      zoneIds.length > 0 &&
      stateIds !== "" &&
      stateIds.length > 0 &&
      cityIds !== "" &&
      cityIds.length > 0 &&
      shift !== null &&
      shift !== 0
    ) {
      const editUserDetails = {
        desingation: {
          designationID: reportDesignation,
        },
        userId: props.userID,
        fullName: fullname,
        email: emailaddress,
        profilePic: imgUrl,
        countryCode: countryCode,
        contact: JSON.parse(mobilenum),
        code: usercode,
        enableStatus: enableStatus,
        managerId: manager,
        shiftID: shift,
        mapType: mapByVal.value,
        allowMeetings: minMeetingRange,
        stateSpecificHoliday: stateForHoliday,
        baseLoc: {
          latitude: JSON.stringify(latLan.lat),
          longitude: JSON.stringify(latLan.lng),
          location: location,
        },
      };
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: travelizeAuth,
        body: JSON.stringify(editUserDetails),
      };

      fetch(`${baseURL}/api/User/EditUser`, requestOption)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            deleteOldRegion(props.userID);
            closeModel();
            props.getUserDetails();
            swal.showAlert("Success", `${res.message}`, "success");
          } else {
            toast.error(res.errorMessage, { autoClose: 8000 });
          }
        });
    } else {
      setFieldReq(true);
      setAlertMessage({
        alertType: "fails",
        message: "Required",
      });
    }
  };
  // EDIT USER END

  // DELETE OLD REGION START
  const deleteOldRegion = (resUserId) => {
    let requestOption = {
      method: "POST",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(
      `${baseURL}/api/Zone/DeleteUserRegions?userId=${resUserId}`,
      requestOption
    )
      .then((res) => res.json())
      .then((res) => {
        addZoneStateCity(resUserId);
      })
      .catch((error) => {
        console.log("ERROR :", error);
        setErrorMessage(error.message);
      });
  };
  // DELETE OLD REGION END

  //  ADDING ZONE STATE AND CITY BY USER START
  const addZoneStateCity = (resUserId) => {
    const zoneStateCity = city.map((item) => {
      return { ...item, userId: resUserId };
    });
    state.forEach((s_state) => {
      if (
        zoneStateCity.filter((zsc) => zsc.stateId === s_state.stateId).length ==
        0
      ) {
        zoneStateCity.push({ ...s_state, userId: resUserId });
      }
    });
    zone.forEach((z_Zone) => {
      if (
        zoneStateCity.filter((zsc) => zsc.zoneId === z_Zone.zoneId).length == 0
      ) {
        zoneStateCity.push({ ...z_Zone, userId: resUserId });
      }
    });

    let requestOption = {
      method: "POST",
      mode: "cors",
      headers: travelizeAuth,
      body: JSON.stringify(zoneStateCity),
    };

    fetch(`${baseURL}/api/Zone/AddUserRegions`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          console.log("REGION-UPDATE::", res);
        } else {
          toast.error(res.errorMessage, { autoClose: 8000 });
        }
      });
  };
  //  ADDING ZONE STATE AND CITY BY USER END

  const closeModel = () => {
    props.showEditModel();
  };

  return (
    <AddEditFormComponent
      handleClose={closeModel}
      formName={"User Details"}
      formSubTitle={"Please edit the user infomation."}
      sidebarItems={["User Details"]}
      childrens={
        <div style={{ position: " relative" }} className="amc-single-image">
          <form onSubmit={editProfileImg}>
            <div className="row">
              <div className="col-md-3 col-lg-3 col-xl-3">
                <div className="add-user-main-logo-image">
                  {localImage ? (
                    <img src={localImage} alt="" className="add-user-images" />
                  ) : (
                    <img
                      className="add-user-images"
                      src={
                        profileImageUrl !== "" &&
                        profileImageUrl !== null &&
                        profileImageUrl !== "no_img.png"
                          ? `${baseURL}/${profileImageUrl}`
                          : profileimg
                      }
                      alt="Profile Images"
                    />
                  )}
                  <div>
                    <button
                      type="button"
                      className="btn upload-logo"
                      onClick={uploadClick}
                    >
                      <i className="bi bi-camera-fill" />
                    </button>
                    <input
                      id="getFile"
                      type="file"
                      name="filetobase64"
                      accept="image/*"
                      className="btn-primary upload"
                      ref={hiddenFileInput}
                      onChange={handleChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                {profileImageUrl == false && imgFileName ? (
                  <small
                    id={`Error${alertMessage.alertType}`}
                    className="form-text text-muted text-center"
                  >
                    {`${imgFileName}`}
                  </small>
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-9 col-lg-9 col-xl-9">
                <div>
                  <div
                    className="row add-user-image-container-div"
                    style={{ marginTop: "10px" }}
                  >
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Full Name *"
                          className={`${
                            fullname
                              ? "float-input-visible"
                              : "float-hidden float-input"
                          }`}
                        >
                          <input
                            type="text"
                            autoComplete="off"
                            className="form-control add-user-input"
                            id="exampleFormControlInput1"
                            placeholder="Full Name *"
                            value={fullname}
                            onChange={(e) => {
                              setFullname(e.target.value);
                            }}
                            onKeyDown={(e) => textNameValidation(e)}
                            // required
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="User/Employee Id *"
                          className={`${
                            usercode
                              ? "float-input-visible"
                              : "float-hidden float-input"
                          }`}
                        >
                          <input
                            type="text"
                            autoComplete="off"
                            className="form-control add-user-input"
                            id="exampleFormControlInput1"
                            placeholder="User/Employee Id *"
                            value={usercode}
                            onChange={(e) => setUserCode(e.target.value)}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>

                  <div
                    className="row add-user-image-container-div"
                    style={{ marginTop: "10px" }}
                  >
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="E-Mail Address *"
                          className={`${
                            emailaddress
                              ? "float-input-visible"
                              : "float-hidden float-input"
                          }`}
                        >
                          <input
                            type="email"
                            autoComplete="off"
                            className="form-control add-user-input"
                            id="exampleFormControlInput1"
                            placeholder="E-Mail Address *"
                            value={emailaddress}
                            onChange={(e) => setEmailAddress(e.target.value)}
                            required
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <div className="input-mobile-field d-flex">
                          <div className="country-code">
                            <FloatingLabel
                              label="Code *"
                              className={`${
                                countryCode
                                  ? "float-visible-select"
                                  : "float-hidden float-select"
                              }`}
                            >
                              <Select
                                className="react-select-container-list model-select"
                                classNamePrefix="react-select-list"
                                defaultValue={countryCodeList[null]}
                                options={countryCodeList}
                                placeholder="Code *"
                                value={countryVal}
                                onInputChange={countryCodeList.label}
                                onChange={(data) => setCountryCode(data.value)}
                                isSearchable={true}
                                // required
                              />
                            </FloatingLabel>
                          </div>

                          <div className="mobile-num" style={{ width: "100%" }}>
                            <FloatingLabel
                              label="Mobile *"
                              className={`${
                                mobilenum
                                  ? "float-input-visible"
                                  : "float-hidden float-input"
                              }`}
                            >
                              <input
                                type="tel"
                                autoComplete="off"
                                className="form-control add-user-input"
                                id="exampleFormControlInput1"
                                placeholder="Mobile *"
                                value={mobilenum}
                                maxLength={12}
                                onChange={(e) => checkValidation(e)}
                                required
                              />
                            </FloatingLabel>
                            {fieldReq &&
                            (countryCode == "+91"
                              ? mobilenum.toString().length !== 10
                              : mobilenum.toString().length < 6) ? (
                              <small
                                id={`Error`}
                                className="form-text text-muted "
                              >
                                {`${alertMessage.message} - Valid Numbers`}
                                &nbsp;
                                <i className="fa fa-exclamation-circle" />
                              </small>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row add-user-image-container-div">
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Designation *"
                          className={`${
                            reportDesignation
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Select
                            className="react-select-container-list model-select"
                            classNamePrefix="react-select-list"
                            defaultValue={desigationdrop[null]}
                            options={desigationdrop}
                            placeholder="Designation *"
                            value={designationVal}
                            onInputChange={desigationdrop.label}
                            onChange={(data) =>
                              setReportDesignation(data.value)
                            }
                            isSearchable={true}
                            // required
                          />
                        </FloatingLabel>
                        {(fieldReq && reportDesignation === "") ||
                        (fieldReq && reportDesignation === 0) ? (
                          <small
                            id={`Error${alertMessage.alertType}`}
                            className="form-text text-muted "
                          >
                            {alertMessage.message}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Select Reporting *"
                          className={`${
                            manager
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Select
                            className="react-select-container-list model-select"
                            classNamePrefix="react-select-list"
                            defaultValue={managerList[null]}
                            options={managerList}
                            placeholder="Select Reporting *"
                            value={managerVal}
                            onInputChange={managerList.label}
                            onChange={(data) => setManager(data.value)}
                            isSearchable={true}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>
                  <div className="row add-user-image-container-div">
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Select Country *"
                          className={`${
                            countryName
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Select
                            className="react-select-container-list model-select"
                            classNamePrefix="react-select-list"
                            defaultValue={countryList[null]}
                            options={countryList}
                            placeholder="Select Country *"
                            value={
                              countryName ? countryName : countryList.value
                            }
                            onInputChange={countryList.label}
                            onChange={(data) => setCountry(data.value)}
                          />
                        </FloatingLabel>
                        {fieldReq && country === "" ? (
                          <small
                            id={`Error${alertMessage.alertType}`}
                            className="form-text text-muted "
                          >
                            {alertMessage.message}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Select Zone *"
                          className={`${
                            zone.length !== 0
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Multiselect
                            className="select-add-user-model zone model-select"
                            options={zoneList} // Options to display in the dropdown
                            selectedValues={zone} // Preselected value to persist in dropdown
                            onSelect={handleSelectZone} // Function will trigger on select event
                            onRemove={handleRemoveZone} // Function will trigger on remove event
                            showCheckbox={true}
                            displayValue="zoneName" // Property name to display in the dropdown options
                            placeholder={"Select Zone *"}
                            emptyRecordMsg="No options available"
                            avoidHighlightFirstOption={true}
                            closeIcon="cancel"
                            showArrow={true}
                            selectionLimit={3}
                            hidePlaceholder={true}
                          />
                        </FloatingLabel>
                        {fieldReq && zoneIds.length <= 0 ? (
                          <small
                            id={`Error${alertMessage.alertType}`}
                            className="form-text text-muted "
                          >
                            {alertMessage.message}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row add-user-image-container-div">
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Select States *"
                          className={`${
                            state.length !== 0
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Multiselect
                            className="select-add-user-model"
                            options={stateListDropdown} // Options to display in the dropdown
                            selectedValues={state} // Preselected value to persist in dropdown
                            onSelect={handleSelectState} // Function will trigger on select event
                            onRemove={handleRemoveState} // Function will trigger on remove event
                            showCheckbox={true}
                            displayValue="stateName" // Property name to display in the dropdown options
                            placeholder={"Select States *"}
                            emptyRecordMsg="No options available"
                            avoidHighlightFirstOption={true}
                            closeIcon="cancel"
                            groupBy="zoneName"
                            showArrow={true}
                            hidePlaceholder={true}
                          />
                        </FloatingLabel>
                        {fieldReq && stateIds.length <= 0 ? (
                          <small
                            id={`Error${alertMessage.alertType}`}
                            className="form-text text-muted "
                          >
                            {alertMessage.message}
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Select Cities *"
                          className={`${
                            city.length !== 0
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Multiselect
                            className="select-add-user-model"
                            options={cityList} // Options to display in the dropdown
                            selectedValues={city} // Preselected value to persist in dropdown
                            onSelect={handleSelectCity} // Function will trigger on select event
                            onRemove={handleRemoveCity} // Function will trigger on remove event
                            showCheckbox={true}
                            displayValue="cityName" // Property name to display in the dropdown options
                            placeholder={"Select Cities *"}
                            emptyRecordMsg="No options available"
                            avoidHighlightFirstOption={true}
                            closeIcon="cancel"
                            groupBy="stateName"
                            showArrow={true}
                            hidePlaceholder={true}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>
                  <div className="row add-user-image-container-div">
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Select Shift *"
                          className={`${
                            shift
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Select
                            className="react-select-container-list model-select"
                            classNamePrefix="react-select-list"
                            defaultValue={shiftDropdownData[null]}
                            options={shiftDropdownData}
                            placeholder="Select Shift"
                            value={shiftVal}
                            onInputChange={shiftDropdownData.label}
                            onChange={(data) => setShift(+data.value)}
                            isSearchable={true}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Map By Method *"
                          className={`${
                            mapByVal
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Select
                            className="react-select-container-list model-select"
                            classNamePrefix="react-select-list"
                            defaultValue={optionsMapByListModel[null]}
                            options={optionsMapByListModel}
                            placeholder="Map User By :"
                            value={mapByVal}
                            onInputChange={optionsMapByListModel.label}
                            onChange={(data) => setMapByVal(data)}
                            isSearchable={true}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>
                  <div className="row add-user-image-container-div">
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="State-Specific Holiday *"
                          className={`${
                            stateForHoliday
                              ? "float-visible-select"
                              : "float-hidden float-select"
                          }`}
                        >
                          <Select
                            className="react-select-container-list model-select"
                            classNamePrefix="react-select-list"
                            options={stateList}
                            placeholder="Select State-Specific Holiday"
                            value={stateSpecificHolidayVal}
                            onInputChange={stateList.label}
                            onChange={(data) => setStateForHoliday(data.label)}
                            isSearchable={true}
                            autoComplete={false}
                            required
                          />
                        </FloatingLabel>
                        {(fieldReq && stateForHoliday === "") ||
                        (fieldReq && stateForHoliday === 0) ? (
                          <small id={`Error`} className="form-text text-muted ">
                            {alertMessage.message}&nbsp;
                            <i className="fa fa-exclamation-circle" />
                          </small>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="mb-3">
                        <FloatingLabel
                          label="Minimum Range For Meetings(KMs)"
                          className={`${
                            minMeetingRange
                              ? "float-input-visible"
                              : "float-hidden float-input"
                          }`}
                        >
                          <input
                            type="text"
                            className="form-control add-user-input"
                            id="exampleFormControlInput1"
                            placeholder="Minimum Range For Meetings(KMs)"
                            value={minMeetingRange}
                            onChange={(e) => {
                              setMinMeetingRange(e.target.value);
                            }}
                          />
                        </FloatingLabel>
                      </div>
                    </div>
                  </div>
                  <div className="row add-user-image-container-div">
                    <div className="col-md-8 col-lg-6">
                      <div className="mb-3 input-address-location">
                        <FloatingLabel
                          label="Location *"
                          className={`${
                            location
                              ? "float-input-visible"
                              : "float-hidden float-input"
                          }`}
                        >
                          <textarea
                            rows="3"
                            cols="20"
                            name="locationtxt"
                            wrap="hard"
                            className="form-control form-textarea add-user-input"
                            id="exampleFormControlInput1"
                            placeholder="Location (Please click the icon for location)"
                            value={location ?? ""}
                            readOnly={true}
                            // onChange={(e) => setLocation(e)}
                          />
                        </FloatingLabel>
                        {fieldReq && location === "" ? (
                          <small
                            id={`Error${alertMessage.alertType}`}
                            className="form-text text-muted "
                          >
                            {alertMessage.message}
                          </small>
                        ) : (
                          ""
                        )}
                        <OverlayTrigger
                          placement={"right"}
                          delay={{ show: 250, hide: 300 }}
                          overlay={
                            <Tooltip id={`tooltip-googlemap`}>
                              Google Maps
                            </Tooltip>
                          }
                        >
                          <div>
                            <i
                              className="bi bi-geo-alt"
                              onClick={openGoogleMaps}
                            />
                          </div>
                        </OverlayTrigger>
                      </div>
                    </div>
                  </div>
                  <div className="row add-user-image-container-div">
                    <div className="col-md-6 col-lg-6">
                      <div className="mt-3">
                        <span className="enable-status d-flex">
                          <h5>Enable</h5>
                          <span className="enable-radio d-flex">
                            <div className="form-check enable-radio-status">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                checked={enableStatus == 1 ? true : false}
                                onChange={() => {
                                  setEnableStatus(1);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Yes
                              </label>
                            </div>
                            <div className="form-check enable-radio-status">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                                checked={enableStatus == 0 ? true : false}
                                onChange={() => {
                                  setEnableStatus(0);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault2"
                              >
                                No
                              </label>
                            </div>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="add-page-save-cancel">
              {showAlert ? (
                <div className={`response-message ${alertMessage.alertType}`}>
                  <p>{alertMessage.message}</p>
                </div>
              ) : (
                ""
              )}
              <SBSaveUpdateBtn btnName="Update" />
              <SbCancelBtn
                btnName="Cancel"
                onClickEffect={props.showEditModel}
              />
            </div>
          </form>
          {googleMapsModel && (
            <GoogleMapAddressModel
              googleMapsModel={googleMapsModel}
              openGoogleMaps={openGoogleMaps}
              latLan={latLan}
              setLatLan={setLatLan}
              address={address}
              setLocation={setLocation}
            />
          )}
        </div>
      }
    />
    // <div show={props.editusermodelshow} onHide={props.showEditModel}>
    //   <div className="add-user-details-container">
    //     <div className="add-user-details-first-div">
    //       <div className="machines-logo-div">
    //         <div className="logotext">
    //           <div className="logo profile-mini">
    //             <Link className="travelize_logo" to="/dashboard">
    //               <img
    //                 src={SalesBee}
    //                 alt="product-title-img"
    //                 className="salesbee-logo"
    //               />
    //             </Link>
    //           </div>
    //         </div>
    //       </div>
    //       <div
    //         className="add-user-details-menus"
    //         onClick={toggleMachineDetails}
    //       >
    //         <div
    //           className={`add-user-details-menu-numbers ${
    //             activeMenu === 1 ? "active" : "inactive"
    //           }`}
    //         >
    //           <p className="add-user-details-menu-number-one">
    //             <span>01</span>
    //           </p>
    //           <div className="add-user-details-menu-name"> User Details</div>
    //         </div>
    //       </div>
    //     </div>
    //     <div className="add-user-details-second-div">
    //       <div className="add-user-details-second-div-header">
    //         <div className="back-btn" onClick={closeModel}>
    //           <img
    //             src="../../../../images/DefaultImages/back-btn-arrow.svg"
    //             alt=""
    //           />
    //         </div>
    //         <div>
    //           <h4>User Details</h4>
    //           <p>Please enter user infomation and proceed to the next step.</p>
    //         </div>
    //       </div>

    //     </div>
    //   </div>
    // </div>
  );
};

export default UpdateUserData;
